import { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import LS from '../styles/layoutStyled';
import CS from '../styles/componentStyled';
import styled from 'styled-components';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
  entranceAddStateRecoil,
  orderModifyStateRecoil,
  orderAutoSortStateRecoil,
  noticeModifyStateRecoil,
  interruptStateRecoil,
  lineMoveStateRecoil,
  pourStateRecoil,
  pourListStateRecoil,
  entrySiteModifyStateRecoil,
  currentLocationStateRecoil,
  roomWorkNumModifyStateRecoil,
} from '../atom/ModalAtom';
import Header3 from '../component/Header3';
import ConfirmModal from '../modal/ConfirmModal';
import EntranceAdd from '../modal/input/EntranceAdd';
import OrderModify from '../modal/input/OrderModify';
import OrderAutoSort from '../modal/input/OrderAutoSort';
import NoticeModify from '../modal/input/NoticeModify';
import Interrupt from '../modal/input/Interrupt';
import LineMove from '../modal/input/LineMove';
import Pour from '../modal/input/Pour';
import PourList from '../modal/input/PourList';
import EntrySiteModify from '../modal/input/EntrySiteModify';
import RoomDetailSideBox from '../component/RoomDetailSideBox';
import { userIdState } from '../atom/TokenAtom';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { EntrySiteDto, RoomInforDto, RoomPeoplesDto } from '../model/room.dto';
import { MyInforDto, SignInDto } from '../model/user.dto';
import EntryList from '../component/EntryList';
import { participationStateRecoil } from '../atom/ParticipationAtom';
import { socketio } from '../api/socket.api';
import eventbus from '../api/eventbus';
import { authAPI, roomAPI } from '../api/axiosIndex';
import { Icon } from '../component/Icon';
import {
  locationShareStateRecoil,
  roomIdStateRecoil,
  roomPeoplesUserIdsStateRecoil,
} from '../atom/RoomAtom';
import CurrentLocation from '../modal/input/CurrentLocation';
import WorkNumModiFy from '../modal/input/WorkNumModiFy';
import {
  refreshDataStateRecoil,
  socketInitializeRecoil,
} from '../atom/CommonAtom';
import { fullLoadingStateRecoil } from '../atom/CommonAtom';
import { IMAGES } from '../assets/images';
import { Image } from '../component/Image';
import RoomWorkNumModiFy from '../modal/input/RoomWorkNumModiFy';

declare global {
  interface Window {
    onLocationUpdate: (latitude: number, longitude: number) => void;
  }
}

const RoomDetail = () => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const paritcipationFlag = useRecoilValue(participationStateRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const [userId, setUserId] = useRecoilState(userIdState);

  const navigate = useNavigate();

  const { id } = useParams<{ id: string }>();

  const noticeBoxRef = useRef<HTMLDivElement>(null);
  const entranceBoxRef = useRef<HTMLDivElement>(null);
  const autoBtnRef = useRef<HTMLButtonElement>(null);
  const audioRef = useRef<HTMLAudioElement>(null);

  const [roomDetailSideBox, setRoomDetailSideBox] = useState(false);
  const [noticeBoxHeight, setNoticeBoxHeight] = useState<number>(0);
  const [entranceBoxHeight, setEntranceBoxHeight] = useState<number>(0);
  const [myInfors, setMyInfors] = useState<MyInforDto | null>(null);
  const [roomInfor, setRoomInfor] = useState<RoomInforDto | null>(null);
  const [roomPeoples, setRoomPeoples] = useState<RoomPeoplesDto | null>(null);
  const [userPosition, setUserPosition] = useState<string | undefined>('');
  const [borrowedIds, setBorrowedIds] = useState<number[]>([]);
  const [delLineId, setDelLineId] = useState<number | null>(null);
  const [pickLineId, setPickLineId] = useState<number | null>(null);
  const [listAddState, setListAddState] = useState(false);
  const [tabDelState, setTabDelState] = useState(false);
  const [entrySiteDelState, setEntrySiteDelState] = useState(false);
  const [ctrlBtnBoxActive, setCtrlBtnBoxActive] = useState(false);
  const [checkIdArray, setCheckIdArray] = useState<string[]>([]);
  const [workStartChecked, setWorkStartChecked] = useState<boolean>(false);
  const [entrySite, setEntrySite] = useState<EntrySiteDto | null>(null);
  const [latitude, setLatitude] = useState<string>('');
  const [longitude, setLongitude] = useState<string>('');
  const [entranceState, setEntranceState] = useState<boolean>(false);
  const [exitState, setExitState] = useState<boolean>(false);
  // const [isEntrance, setIsEntrance] = useState<boolean>(false);

  const [refreshData, setRefreshData] = useRecoilState(refreshDataStateRecoil);
  const socketInitialize = useRecoilValue(socketInitializeRecoil);
  const roomIdState = useRecoilValue(roomIdStateRecoil);
  const [roomWorkNumModifyState, setRoomWorkNumModifyState] = useRecoilState(
    roomWorkNumModifyStateRecoil,
  );
  const [entranceAddState, setEntranceAddState] = useRecoilState(
    entranceAddStateRecoil,
  );
  const [orderModifyState, setOrderModifyState] = useRecoilState(
    orderModifyStateRecoil,
  );
  const [orderAutoSortState, setOrderAutoSortState] = useRecoilState(
    orderAutoSortStateRecoil,
  );
  const [noticeModifyState, setNoticeModifyState] = useRecoilState(
    noticeModifyStateRecoil,
  );
  const [interruptState, setInterruptState] =
    useRecoilState(interruptStateRecoil);
  const [lineMoveState, setLineMoveState] = useRecoilState(lineMoveStateRecoil);
  const [pourState, setPourState] = useRecoilState(pourStateRecoil);
  const [pourListState, setPourListState] = useRecoilState(pourListStateRecoil);
  const [entrySiteModifyState, setEntrySiteModifyState] = useRecoilState(
    entrySiteModifyStateRecoil,
  );
  const [currentLocationState, setCurrentLocationState] = useRecoilState(
    currentLocationStateRecoil,
  );
  const [locationShareState, setLocationShareState] = useRecoilState(
    locationShareStateRecoil,
  );
  const [roomPeoplesUserIds, setRoomPeoplesUserIds] = useRecoilState(
    roomPeoplesUserIdsStateRecoil,
  );
  const setFullLoading = useSetRecoilState(fullLoadingStateRecoil);

  // 위도, 경도 문자열을 숫자로 변환
  const userLat = parseFloat(latitude);
  const userLng = parseFloat(longitude);

  // Haversine 거리 계산 함수 (미터 단위 반환)
  function getDistanceFromLatLonInM(
    lat1: number,
    lon1: number,
    lat2: number,
    lon2: number,
  ) {
    const R = 6371000; // 지구 반지름 (m)
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  // 입차 여부 확인
  const handleIsEntrance = async () => {
    try {
      const response = await roomAPI.getEntryStatus(Number(id));
      return response.data.lineIds;
    } catch (err: any) {
      console.log(err);
      return [];
    }
  };

  // 업무 시작 && 입차지 존재 && 위도 경도 값이 변경될 시 자동 입출차 useEffect
  useEffect(() => {
    const checkEntranceStatus = async () => {
      if (entrySite && !isNaN(userLat) && !isNaN(userLng) && workStartChecked) {
        // 입차 여부 확인
        const entrance = await handleIsEntrance();
        const isEntrance = entrance.length > 0;

        const distance = getDistanceFromLatLonInM(
          entrySite.latitude,
          entrySite.longitude,
          userLat,
          userLng,
        );

        // 입차지 반경에 현재 위치가 있을 때
        if (distance <= entrySite.radius) {
          // 이미 입차 && 다른 라인 입차되어 있는 경우 요청이 더 이상 안되게 처리해야함
          // 자동 입차의 경우 여러 라인이 있을 경우 첫번째 라인에 입차
          if (!isEntrance) {
            handleEntrance(Number(roomInfor?.lines[0].id));
          }
        }
        // 입차지 반경에서 벗어났을 때
        else {
          // 이미 출차 && 다른 라인 입차되어 있는 경우 요청이 더 이상 안되게 처리해야함
          if (isEntrance) {
            handleExit(Number(entrance[0]));
          }
        }
      }
    };

    checkEntranceStatus();
  }, [latitude, longitude, entrySite, workStartChecked]);

  // 업무 시작 컨트롤 버튼 클릭 시 상태 변경
  const handleWorkStartCheckBoxChange = async () => {
    try {
      await roomAPI.postWorkStart(Number(id));
      setWorkStartChecked(!workStartChecked);
      if (workStartChecked) {
        setError('업무가 종료되었습니다.');
      } else if (!workStartChecked) {
        setConfirm('업무가 시작되었습니다.');
      }
    } catch (err: any) {
      console.log(err);
    }
  };

  // 업무 시작 여부 조회
  const getWorkStart = async () => {
    try {
      const response = await roomAPI.getWorkStart(Number(id));
      setWorkStartChecked(response.data.isWorking);
    } catch (err: any) {
      console.log(err);
    }
  };

  // 입차지 정보 조회
  const getEntrySite = async () => {
    try {
      const response = await roomAPI.getEntrySite(Number(id));
      setEntrySite(response.data);
    } catch (err: any) {
      setEntrySite(null);
      console.log(err);
    }
  };

  // 현재 위치 업데이트
  const postCurrentLocation = async (latitude: number, longitude: number) => {
    if (isNaN(latitude) || isNaN(longitude)) {
      return;
    }

    try {
      await roomAPI.postCurrentLocation(
        Number(id),
        Number(latitude),
        Number(longitude),
      );
    } catch (err: any) {
      console.log(err);
    }
  };

  // 입차지 삭제
  const handleEntrySiteDel = async () => {
    if (!entrySite) {
      setError('입차지가 존재하지 않습니다.');
      setEntrySiteDelState(false);
      return;
    }

    try {
      await roomAPI.delEntrySite(Number(id));
      socketio.entrySiteUpdate(Number(id));
      setEntrySiteDelState(false);
      setConfirm('입차지가 삭제되었습니다.');
      setEntrySite(null);
    } catch (err: any) {
      console.log(err);
    }
  };

  // 스와이퍼 페이지네이션
  const pagination = {
    clickable: true,
    renderBullet: function (index: number, className: string) {
      return '<span class="' + className + '">' + (index + 1) + '</span>';
    },
  };

  // 내 정보 조회
  const fetchMyInfors = async () => {
    try {
      const response = await authAPI.getMyInfor();
      setMyInfors(response.data);
    } catch (err: any) {
      console.log(err);
    }
  };

  // 방 정보 조회
  const getRoomInfor = async () => {
    try {
      const response = await roomAPI.getRoomInfor(Number(id));
      setRoomInfor(response.data);
    } catch (err: any) {
      navigate('/myroomlist');
      setError('방장에 의해 퇴장당하였습니다.');
    }
  };

  // 방 인원 조회
  const getRoomPeoples = async () => {
    try {
      const response = await roomAPI.getRoomPeoples(Number(id));
      setRoomPeoples(response.data);

      // 방장 확인
      const position = response.data.find(
        (person: { userId: number }) => person.userId === userId,
      )?.position;
      setUserPosition(position);

      // 방에 있는 유저 userId 저장
      const roomPeoplesUserIdsArr: number[] = response.data.map(
        (person) => person.userId,
      );
      setRoomPeoplesUserIds(roomPeoplesUserIdsArr);

      // 현위치 모달 뷰 권한
      const isLocationViewer = response.data.find(
        (person: { userId: number }) => person.userId === userId,
      )?.isLocationViewer;
      setLocationShareState(isLocationViewer || false);

      // 용차 유저 구분
      const borrowedIdsArr: number[] = response.data
        .filter((person) => person.position === 'Borrowed')
        .map((person) => person.id);
      setBorrowedIds(borrowedIdsArr);
    } catch (err: any) {
      console.log(err);
    }
  };

  // 입출차 탭 추가
  const handleListAdd = async () => {
    try {
      await roomAPI.postLineAdd(Number(id));
      socketio.participation(Number(id));
      setListAddState(false);
      getRoomInfor();
      setConfirm('입출차 탭이 추가되었습니다.');
    } catch (err: any) {
      setError('입출차 탭 추가에 실패하였습니다.');
    }
  };

  // 입출차 탭 삭제
  const handleTabDel = async () => {
    try {
      await roomAPI.delLine(Number(delLineId));
      socketio.participation(Number(id));
      setTabDelState(false);
      getRoomInfor();
      setConfirm('입출차 탭이 삭제되었습니다.');
    } catch (err: any) {
      setError('입출차 탭 삭제에 실패하였습니다.');
    }
  };

  // 입차
  const handleEntrance = async (lineId: number) => {
    try {
      await roomAPI.postEntrance(lineId);
      socketio.entry(Number(lineId));
      setConfirm('입차가 되었습니다.');
      setRefreshData((prev) => !prev);
    } catch (err: any) {
      setError('이미 입차가 되어있습니다.');
    }
  };

  // 입차 취소
  const handleEntranceCancle = async (lineId: number) => {
    try {
      await roomAPI.delEntranceCancle(Number(lineId));
      // await socketio.entryCancel(Number(entryId), Number(lineId));
      await socketio.entry(Number(lineId));
      setConfirm('입차가 취소되었습니다.');
    } catch {
      setError('입차가 되어있지 않습니다.');
    }
  };

  // 출차
  const handleExit = async (lineId: number) => {
    try {
      await roomAPI.delExit(lineId);
      socketio.entry(Number(lineId));
      setConfirm('출차가 완료되었습니다.');
      setRefreshData((prev) => !prev);
    } catch {
      setError('입차가 되어있지 않습니다.');
    }
  };

  // 입차 리스트 업데이트
  const handleListUpdate = () => {
    getRoomInfor();
    getRoomPeoples();
    fetchMyInfors();
    setRefreshData((prev) => !prev);
  };

  // 출차 승인(방장 기능)
  const delOrderExit = async (lineId: number) => {
    try {
      await roomAPI.delOrderExit(Number(lineId), checkIdArray);
      for (const entryId of checkIdArray) {
        await socketio.entryOrder(Number(entryId), Number(lineId));
      }
      await socketio.entry(Number(lineId));
      setCheckIdArray([]);
      setConfirm('출차가 완료되었습니다.');
    } catch (err: any) {
      console.log(err);
    }
  };

  // 입차 취소(방장 기능)
  const delOrderCancle = async (lineId: number) => {
    try {
      await roomAPI.delOrderCancle(Number(lineId), checkIdArray);
      for (const entryId of checkIdArray) {
        await socketio.entryCancel(Number(entryId), Number(lineId));
      }
      await socketio.entry(Number(lineId));
      setCheckIdArray([]);
      setConfirm('입차가 취소되었습니다.');
    } catch (err: any) {
      console.log(err);
    }
  };

  // 라인 이동(방장 기능)
  const handleLineMove = (lineId: number) => {
    if (roomInfor?.lines.length === 1) {
      setError('이동할 라인이 없습니다.');
      return;
    }

    setPickLineId(lineId);
    setLineMoveState(true);
  };

  // 상단 공지 박스 높이 계산 useEffect
  useEffect(() => {
    const handleResize = (entries: ResizeObserverEntry[]) => {
      entries.forEach((entry) => {
        // 공지사항 높이 계산
        if (entry.target === noticeBoxRef.current) {
          const { height } = entry.contentRect;
          const computedStyle = window.getComputedStyle(noticeBoxRef.current!);
          const paddingTop = parseFloat(computedStyle.paddingTop);
          const paddingBottom = parseFloat(computedStyle.paddingBottom);
          const borderTop = parseFloat(computedStyle.borderTopWidth);
          const borderBottom = parseFloat(computedStyle.borderBottomWidth);
          const totalHeight =
            height + paddingTop + paddingBottom + borderTop + borderBottom;
          setNoticeBoxHeight(Math.ceil(totalHeight));
        }

        // 입차지 정보 높이 계산
        //   if (entry.target === entranceBoxRef.current) {
        //     const { height } = entry.contentRect;
        //     const computedStyle = window.getComputedStyle(
        //       entranceBoxRef.current!,
        //     );
        //     const paddingTop = parseFloat(computedStyle.paddingTop);
        //     const paddingBottom = parseFloat(computedStyle.paddingBottom);
        //     const borderTop = parseFloat(computedStyle.borderTopWidth);
        //     const borderBottom = parseFloat(computedStyle.borderBottomWidth);
        //     const totalHeight =
        //       height + paddingTop + paddingBottom + borderTop + borderBottom;
        //     setEntranceBoxHeight(Math.ceil(totalHeight));
        //   }
      });
    };

    const resizeObserver = new ResizeObserver(handleResize);

    if (noticeBoxRef.current) {
      resizeObserver.observe(noticeBoxRef.current);
    }
    // if (entranceBoxRef.current) {
    //   resizeObserver.observe(entranceBoxRef.current);
    // }

    return () => {
      if (noticeBoxRef.current) {
        resizeObserver.unobserve(noticeBoxRef.current);
      }
      // if (entranceBoxRef.current) {
      //   resizeObserver.unobserve(entranceBoxRef.current);
      // }
    };
  }, []);

  // 업무 시작 여부 조회 useEffect
  useEffect(() => {
    getWorkStart();
  }, []);

  // 입차지 정보 조회 useEffect
  useEffect(() => {
    getEntrySite();
  }, []);

  // 입차지 정보 수정시 socket 이벤트 발생시 입차지 정보 조회 useEffect
  useEffect(() => {
    eventbus.on('entrySiteUpdate', getEntrySite);

    return () => {
      eventbus.off('entrySiteUpdate', getEntrySite);
    };
  }, []);

  // 방 입장시 정보 조회 useEffect
  useEffect(() => {
    const handleRoomInfor = () => {
      getRoomPeoples();
      getRoomInfor();
      fetchMyInfors();
    };

    eventbus.on('participation', handleRoomInfor);
    eventbus.on('entrySiteUpdate', handleRoomInfor);

    return () => {
      eventbus.off('participation', handleRoomInfor);
      eventbus.off('entrySiteUpdate', handleRoomInfor);
    };
  }, []);

  // 공지사항 수정시 소켓 알림 소리 및 토스팅 재생 useEffect
  useEffect(() => {
    const handleNoticeUpdate = (data: { roomId: number }) => {
      if (Number(id) === data.roomId) {
        getRoomInfor();
        setConfirm('공지사항이 수정되었습니다.');

        const playNotificationSound = async (retryCount = 0) => {
          if (!audioRef.current) {
            return;
          }

          try {
            audioRef.current.currentTime = 0;
            await audioRef.current.play();
          } catch (error) {
            if (retryCount < 3) {
              setTimeout(() => {
                playNotificationSound(retryCount + 1);
              }, 1000);
            }
          }
        };

        playNotificationSound();
      }
    };

    eventbus.on('noticeUpdate', handleNoticeUpdate);

    return () => {
      eventbus.off('noticeUpdate', handleNoticeUpdate);
    };
  }, [roomIdState, id]);

  // 입차 리스트 선택 시 컨트롤 버튼 박스 활성화(방장 기능)
  useEffect(() => {
    if (checkIdArray.length > 0) {
      setCtrlBtnBoxActive(true);
    } else if (checkIdArray.length === 0) {
      setCtrlBtnBoxActive(false);
    }
  }, [checkIdArray]);

  // 업무 시작이 활성화 되있을 경우 앱에서 위치 정보 받아서 위치 업데이트 useEffect
  useEffect(() => {
    if (workStartChecked) {
      window.onLocationUpdate = (latitude: number, longitude: number) => {
        setLatitude(String(latitude));
        setLongitude(String(longitude));
        postCurrentLocation(latitude, longitude);
      };
    } else {
      window.onLocationUpdate = () => {
        console.log('업무 종료 위치 정보 업데이트 해제');
      };
    }

    return () => {
      window.onLocationUpdate = () => {
        console.log('업무 종료 위치 정보 업데이트 해제');
      };
    };
  }, [workStartChecked]);

  // 토큰 업데이트
  const handleTokenUpdate = async () => {
    try {
      const newToken = await authAPI.getNewToken(
        String(sessionStorage.getItem('refreshToken')),
      );
      sessionStorage.setItem('accessToken', newToken.data.accessToken);
      sessionStorage.setItem('refreshToken', newToken.data.refreshToken);
      sessionStorage.setItem(
        'accessExpire',
        (Date.now() + newToken.data.accessExpire * 1000).toString(),
      );
      sessionStorage.setItem(
        'refreshExpire',
        (Date.now() + newToken.data.refreshExpire * 1000).toString(),
      );
    } catch (err: any) {
      console.log(err);
    }
  };

  // 재로그인
  const handleReSignin = async () => {
    const userInfor = JSON.parse(String(localStorage.getItem('userInfor')));

    if (userInfor) {
      const dto: SignInDto = {
        passid: userInfor.passid,
        password: userInfor.password,
      };

      const token = await authAPI.signIn(dto);

      sessionStorage.setItem('accessToken', token.data.accessToken);
      sessionStorage.setItem('refreshToken', token.data.refreshToken);
      sessionStorage.setItem(
        'accessExpire',
        (Date.now() + token.data.accessExpire * 1000).toString(),
      );
      sessionStorage.setItem(
        'refreshExpire',
        (Date.now() + token.data.refreshExpire * 1000).toString(),
      );
    } else {
      localStorage.clear();
      sessionStorage.clear();
      navigate('/login');
      setError('로그인 세션이 만료되었습니다.\n다시 로그인해 주세요.');
    }
  };

  // 소켓 해제 및 다시 연결 테스트
  const handleSocketSignin = async () => {
    const now = Date.now();
    const accessToken = String(sessionStorage.getItem('accessToken'));
    const accessExpire = Number(sessionStorage.getItem('accessExpire'));
    const refreshExpire = Number(sessionStorage.getItem('refreshExpire'));

    // accessExpire가 유효할 경우
    if (now < accessExpire) {
      await socketio.signin(accessToken);
      await socketio.participation(Number(id));
    }
    // refreshExpire가 유효할 경우
    else if (now < refreshExpire) {
      await handleTokenUpdate();
      await socketio.signin(String(sessionStorage.getItem('accessToken')));
      await socketio.participation(Number(id));
    }
    // refreshExpire까지 유효하지 않을 경우
    else {
      await handleReSignin();
      await socketio.signin(String(sessionStorage.getItem('accessToken')));
      await socketio.participation(Number(id));
    }
  };

  useEffect(() => {
    if (socketInitialize) {
      setTimeout(() => {
        handleSocketSignin();
      }, 100);
    }
  }, [socketInitialize]);

  return (
    <div key={paritcipationFlag}>
      <audio ref={audioRef} controls style={{ display: 'none' }}>
        <source src="/notification_sound.wav" type="audio/wav" />
        브라우저가 audio 태그를 지원하지 않습니다.
      </audio>
      <Wrap>
        <Header3
          title={roomInfor?.title !== undefined ? roomInfor?.title : ''}
          hamBtnClick={() => setRoomDetailSideBox(true)}
        />
        <LS.RoomDetailCntLayout>
          <TopWrap className={workStartChecked ? 'active' : ''}>
            <div className="btn-wrap">
              {(userPosition === 'Master' || locationShareState) && (
                <button
                  className="map-btn img-box"
                  onClick={() => {
                    if (!entrySite) {
                      setError('입차지가 존재하지 않습니다.');
                      return;
                    } else {
                      setCurrentLocationState(true);
                    }
                  }}
                >
                  <Image src={IMAGES.MapIcon} />
                </button>
              )}
              {userPosition === 'Master' && (
                <>
                  <button
                    className="edit-btn img-box"
                    onClick={() => setEntrySiteModifyState(true)}
                  >
                    <Image src={IMAGES.SettingIcon} />
                  </button>
                  {/* 입차지 삭제 버튼 */}
                  {/* <button
                    className="img-box del-btn"
                    onClick={() => {
                      if (!entrySite) {
                        setError('입차지가 존재하지 않습니다.');
                        return;
                      } else {
                        setEntrySiteDelState(true);
                      }
                    }}
                  >
                    <Icon name="TrashIcon" size="100%" color="#AAA" />
                  </button> */}
                </>
              )}
            </div>
            <div className="ctrl-wrap">
              <h1>업무 시작</h1>
              <CS.CtrlBox>
                <input
                  type="checkbox"
                  id="work_start"
                  checked={workStartChecked}
                  onChange={handleWorkStartCheckBoxChange}
                />
                <label htmlFor="work_start"></label>
              </CS.CtrlBox>
            </div>
          </TopWrap>
          <NoticeBox ref={noticeBoxRef}>
            <div className="ico-box">
              <span className="img-box">
                <Icon name="LoudSpeakerIcon" size="100%" color="#437BE6" />
              </span>
            </div>
            <div className="text-wrap">
              <div className="text-box">
                <h1>공지사항</h1>
                <p>{roomInfor?.notice}</p>
              </div>
              {userPosition === 'Master' && (
                <div className="btn-box">
                  <button
                    className="img-box"
                    onClick={() => setNoticeModifyState(true)}
                  >
                    <Image src={IMAGES.SettingIcon} />
                  </button>
                </div>
              )}
            </div>
          </NoticeBox>
          {/* <EntranceBox ref={entranceBoxRef}>
            <div className="ico-box">
              <span className="img-box">
                <Icon name="MarkerIcon" size="100%" color="#DD6868" />
              </span>
            </div>
            <div className="text-wrap">
              <div className="text-box">
                {entrySite ? (
                  <>
                    <p>
                      {entrySite.address.split('@')[0]}{' '}
                      {entrySite.address.split('@')[1]}
                      <br />
                      반경 : {entrySite.radius}m
                    </p>
                  </>
                ) : (
                  <>
                    <p>입차지가 존재하지 않습니다.</p>
                  </>
                )}
              </div>
              <div className="btn-box">
                {(userPosition === 'Master' || locationShareState) && (
                  <button
                    className="img-box map-btn"
                    onClick={() => {
                      if (!entrySite) {
                        setError('입차지가 존재하지 않습니다.');
                        return;
                      } else {
                        setCurrentLocationState(true);
                      }
                    }}
                  >
                    <Icon name="MapIcon" size="100%" color="#AAA" />
                  </button>
                )}
                {userPosition === 'Master' && (
                  <>
                    <button
                      className="img-box edit-btn"
                      onClick={() => setEntrySiteModifyState(true)}
                    >
                      <Icon name="EditIcon" size="100%" color="#AAA" />
                    </button>
                    <button
                      className="img-box del-btn"
                      onClick={() => {
                        if (!entrySite) {
                          setError('입차지가 존재하지 않습니다.');
                          return;
                        } else {
                          setEntrySiteDelState(true);
                        }
                      }}
                    >
                      <Icon name="TrashIcon" size="100%" color="#AAA" />
                    </button>
                  </>
                )}
              </div>
            </div>
          </EntranceBox> */}
          <SwiperBox
            $noticeBoxHeight={noticeBoxHeight}
            $entranceBoxHeight={entranceBoxHeight}
          >
            <Swiper
              modules={[Pagination]}
              spaceBetween={16}
              slidesPerView={1}
              pagination={pagination}
              onSlideChange={() => {
                setCheckIdArray([]);
              }}
            >
              {roomInfor?.lines.map((line) => (
                <SwiperSlide key={line.id}>
                  <ListBox>
                    <CS.EntryAndExitCardListBox>
                      <EntryList
                        roomInfor={roomInfor}
                        lineId={line.id}
                        refreshData={refreshData}
                        userPosition={userPosition}
                        checkIdArray={checkIdArray}
                        setCheckIdArray={setCheckIdArray}
                      />
                    </CS.EntryAndExitCardListBox>
                  </ListBox>
                  <SubBtnBox>
                    {/* 자동 정렬 */}
                    {userPosition === 'Master' && (
                      <CS.Btn5Type1
                        className={line.autoSort ? 'on' : ''}
                        ref={autoBtnRef}
                        onClick={() => {
                          setOrderAutoSortState(true);
                          setPickLineId(line.id);
                        }}
                      >
                        <span className="img-box">
                          {line.autoSort && (
                            <Icon name="AutoOnIcon" size="100%" color="#fff" />
                          )}
                          {!line.autoSort && (
                            <Icon name="AutoOffIcon" size="100%" color="#fff" />
                          )}
                        </span>
                      </CS.Btn5Type1>
                    )}
                    {/* 입차 추가 */}
                    {userPosition === 'Master' && (
                      <CS.Btn5Type2
                        onClick={() => {
                          setEntranceAddState(true);
                          setPickLineId(line.id);
                        }}
                        disabled={line.autoSort}
                      >
                        <span className="img-box">
                          <Icon name="PlusIcon" size="100%" color="#fff" />
                        </span>
                      </CS.Btn5Type2>
                    )}
                    {/* 순번 수정 */}
                    {userPosition === 'Master' && (
                      <CS.Btn5Type2
                        onClick={() => {
                          setOrderModifyState(true);
                          setPickLineId(line.id);
                        }}
                        disabled={line.autoSort}
                      >
                        <span className="img-box">
                          <Icon
                            name="ArrowTopBottomIcon"
                            size="100%"
                            color="#fff"
                          />
                        </span>
                      </CS.Btn5Type2>
                    )}
                    {/* 끼어들기 */}
                    <CS.Btn5Type2
                      onClick={() => {
                        setInterruptState(true);
                        setPickLineId(line.id);
                      }}
                      disabled={line.autoSort}
                    >
                      <span className="img-box">
                        <Icon name="ArrowCurveIcon" size="100%" color="#fff" />
                      </span>
                    </CS.Btn5Type2>
                    {/* 타설 목록 조회 모달 */}
                    <CS.Btn5Type2
                      onClick={() => {
                        setPourListState(true);
                        setPickLineId(line.id);
                      }}
                    >
                      <span className="img-box">
                        <Icon name="PourListIcon" size="100%" color="#fff" />
                      </span>
                    </CS.Btn5Type2>
                    {/* 라인 추가 */}
                    {userPosition === 'Master' && (
                      <CS.Btn5Type3 onClick={() => setListAddState(true)}>
                        <span className="img-box">
                          <Icon name="LineAddIcon" size="100%" color="#fff" />
                        </span>
                      </CS.Btn5Type3>
                    )}
                    {/* 라인 삭제 */}
                    {line.expansion === 'Slave' &&
                      userPosition === 'Master' && (
                        <CS.Btn5Type4
                          onClick={() => {
                            setTabDelState(true);
                            setDelLineId(line.id);
                          }}
                        >
                          <span className="img-box">
                            <Icon name="CloseIcon" size="100%" color="#fff" />
                          </span>
                        </CS.Btn5Type4>
                      )}
                  </SubBtnBox>
                  <BtnBox>
                    <CS.Btn1Type1
                      type="button"
                      onClick={() => handleEntrance(line.id)}
                    >
                      입차
                    </CS.Btn1Type1>
                    <CS.Btn1Type6
                      type="button"
                      onClick={() => handleEntranceCancle(line.id)}
                    >
                      입차
                      <br />
                      취소
                    </CS.Btn1Type6>
                    <CS.Btn1Type3
                      type="button"
                      onClick={() => handleExit(line.id)}
                    >
                      출차
                    </CS.Btn1Type3>
                    <CS.Btn1Type4
                      type="button"
                      onClick={() => {
                        setPourState(true);
                        setPickLineId(line.id);
                      }}
                    >
                      타설
                      <br />
                      완료
                    </CS.Btn1Type4>
                  </BtnBox>
                  <CtrlBtnBox className={ctrlBtnBoxActive ? 'active' : ''}>
                    <CS.Btn1Type5
                      type="button"
                      onClick={() => delOrderExit(line.id)}
                    >
                      출차
                      <br />
                      승인
                    </CS.Btn1Type5>
                    <CS.Btn1Type6
                      type="button"
                      onClick={() => delOrderCancle(line.id)}
                    >
                      입차
                      <br />
                      취소
                    </CS.Btn1Type6>
                    <CS.Btn1Type4
                      type="button"
                      onClick={() => handleLineMove(line.id)}
                    >
                      라인
                      <br />
                      이동
                    </CS.Btn1Type4>
                  </CtrlBtnBox>
                </SwiperSlide>
              ))}
            </Swiper>
          </SwiperBox>
        </LS.RoomDetailCntLayout>
      </Wrap>

      {roomDetailSideBox && (
        <RoomDetailSideBox
          xBtnClick={() => setRoomDetailSideBox(false)}
          roomPeoples={roomPeoples}
          userPosition={userPosition}
          roomId={roomInfor?.id}
          borrowedIds={borrowedIds}
          roomInfor={roomInfor}
          onListUpdate={handleListUpdate}
        />
      )}

      {listAddState && (
        <ConfirmModal
          text="입출차 탭을 추가하시겠습니까?"
          onCancel={() => setListAddState(false)}
          onConfirm={handleListAdd}
        />
      )}

      {tabDelState && (
        <ConfirmModal
          text="정말 입출차 탭을 삭제하시겠습니까? 탭에 있는 입차들은 삭제됩니다."
          onCancel={() => setTabDelState(false)}
          onConfirm={handleTabDel}
        />
      )}

      {entrySiteDelState && (
        <ConfirmModal
          text="정말 입차지를 삭제하시겠습니까?"
          onCancel={() => setEntrySiteDelState(false)}
          onConfirm={handleEntrySiteDel}
        />
      )}

      {roomWorkNumModifyState && (
        <RoomWorkNumModiFy onListUpdate={handleListUpdate} />
      )}

      {entranceAddState && (
        <EntranceAdd
          pickLineId={pickLineId}
          roomInfor={roomInfor}
          onListUpdate={handleListUpdate}
        />
      )}

      {orderModifyState && (
        <OrderModify pickLineId={pickLineId} onListUpdate={handleListUpdate} />
      )}

      {orderAutoSortState && (
        <OrderAutoSort
          roomInfor={roomInfor}
          pickLineId={pickLineId}
          onListUpdate={handleListUpdate}
          roomId={String(id)}
        />
      )}

      {interruptState && (
        <Interrupt
          pickLineId={pickLineId}
          myInfors={myInfors}
          roomInfor={roomInfor}
          onListUpdate={handleListUpdate}
        />
      )}

      {pourState && (
        <Pour pickLineId={pickLineId} onListUpdate={handleListUpdate} />
      )}

      {noticeModifyState && (
        <NoticeModify
          roomId={Number(id)}
          roomNotice={roomInfor?.notice}
          onListUpdate={handleListUpdate}
        />
      )}

      {lineMoveState && (
        <LineMove
          pickLineId={pickLineId}
          roomInforLine={roomInfor?.lines ?? null}
          checkIdArray={checkIdArray}
          roomId={String(id)}
          setCheckIdArray={setCheckIdArray}
          onListUpdate={handleListUpdate}
        />
      )}

      {pourListState && <PourList pickLineId={pickLineId} />}

      {/* 입차지 수정 모달 */}
      {entrySiteModifyState && (
        <EntrySiteModify onListUpdate={handleListUpdate} />
      )}

      {/* 현위치 모달 */}
      {currentLocationState && <CurrentLocation />}
    </div>
  );
};

export default RoomDetail;

export const Wrap = styled.div`
  width: 100%;
`;

export const TopWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  box-sizing: border-box;
  padding: 4px;
  border-radius: 8px;
  &.active {
    background-color: #6cb26e;
    .ctrl-wrap {
      h1 {
        color: #fff;
        font-weight: 700;
      }
      label {
        background-color: #328d35;
        box-sizing: border-box;
        border: 1px solid #fff;
      }
    }
  }
  .btn-wrap {
    display: flex;
    align-items: center;
    gap: 4px;
    button {
      width: 26px;
    }
  }
  .ctrl-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
    h1 {
      font-size: 16px;
      color: #333;
      font-weight: 500;
    }
  }
`;

export const NoticeBox = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 16px 12px 16px 16px;
  background-color: #e8effc;
  border-radius: 8px;
  position: relative;
  display: flex;
  gap: 16px;

  .ico-box {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    .img-box {
      width: 24px;
    }
  }

  .text-wrap {
    width: calc(100% - 58px);
    display: flex;
    gap: 12px;
    .text-box {
      width: 100%;
      > h1 {
        font-size: 14px;
        font-weight: 700;
      }
      > p {
        font-size: 13px;
        line-height: 1.4;
        margin-top: 4px;
        white-space: pre-wrap;
        word-break: break-word;
      }
    }

    .btn-box {
      display: flex;
      flex-direction: column;
      gap: 6px;
      .img-box {
        width: 24px;
        min-width: 24px;
        &.map-btn {
          width: 26px;
          min-width: 26px;
        }
        &.del-btn {
          width: 20px;
          height: 20px;
          min-width: 20px;
        }
      }
    }
  }
`;

export const EntranceBox = styled(NoticeBox)`
  margin-top: 12px;
  background-color: #f4e6e6;
`;

export const SwiperBox = styled.div<{
  $noticeBoxHeight: number;
  $entranceBoxHeight: number;
}>`
  width: 100%;
  box-sizing: border-box;
  padding-top: 12px;
  height: calc(
    100vh - (128px + ${({ $noticeBoxHeight }) => $noticeBoxHeight}px)
  );

  .swiper {
    width: 100%;
    height: 100%;

    .swiper-pagination {
      bottom: 0 !important;

      .swiper-pagination-bullet {
        width: 16px !important;
        height: 16px !important;
        background-color: #555 !important;
        opacity: 0.5 !important;
        margin: 0 5px !important;
        font-size: 12px !important;
        font-weight: 400 !important;
        text-align: center !important;
        line-height: 16px !important;
        color: #fff !important;
        &.swiper-pagination-bullet-active {
          opacity: 1 !important;
          font-weight: 700 !important;
        }
      }
    }
  }
`;
export const ListBox = styled.div`
  height: calc(100% - 160px);
`;
export const SubBtnBox = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  box-sizing: border-box;
  padding-top: 16px;
`;
export const BtnBox = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
  box-sizing: border-box;
  padding: 24px 0 28px 0;
`;

export const CtrlBtnBox = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
  box-sizing: border-box;
  padding: 60px 0 0 0;
  border-radius: 12px 12px 0 0;
  background-color: #fff;
  position: absolute;
  bottom: 28px;
  left: 0;
  transform: translateY(100%);
  transition: transform 0.3s;
  &.active {
    transform: translateY(0);
  }
`;
